module.exports = __webpack_public_path__ + "static/BELEFlyer-37014addd1d729b447232d0c563dd327.png";